// ── Role groups ──────────────────────────────────────────────────────────────
export const ADMIN_ROLES = ["owner", "co_owner", "tech_admin"] as const;
export const MANAGER_ROLES = ["owner", "co_owner", "tech_admin", "sales_manager"] as const;
export const ALL_ROLES = ["owner", "co_owner", "tech_admin", "sales_manager", "coordinator", "recruiter"] as const;

export type UserRole = (typeof ALL_ROLES)[number];

export const isAdmin = (role: string) => (ADMIN_ROLES as readonly string[]).includes(role);
export const isManager = (role: string) => (MANAGER_ROLES as readonly string[]).includes(role);

// ── UI Labels ────────────────────────────────────────────────────────────────
export const MONTH_NAMES = ["Январь", "Февраль", "Март", "Апрель", "Май", "Июнь", "Июль", "Август", "Сентябрь", "Октябрь", "Ноябрь", "Декабрь"] as const;

export const ROLE_LABELS: Record<string, string> = {
  owner: "Владелец",
  co_owner: "Совладелец",
  tech_admin: "Техадмин",
  sales_manager: "МОП",
  coordinator: "Координатор",
  recruiter: "Рекрутер",
};
export const COOKIE_NAME = "app_session_id";
export const ONE_YEAR_MS = 1000 * 60 * 60 * 24 * 365;
export const AXIOS_TIMEOUT_MS = 30_000;
export const UNAUTHED_ERR_MSG = 'Please login (10001)';
export const NOT_ADMIN_ERR_MSG = 'You do not have required permission (10002)';

/**
 * Как должность сотрудника называется НА ПУБЛИЧНЫХ экранах — тех, что видят
 * кандидат и заказчик.
 *
 * Внутренний ROLE_LABELS сюда не годится: «МОП», «Техадмин», «Совладелец» —
 * наш рабочий жаргон, кандидату он ничего не говорит и звучит небрежно.
 * Владелица 21.09.2026: «Интервью проводит: Натали — а надо должность,
 * рекрутёр агентства Change».
 *
 * Запасной вариант честен: строка берётся из поля «рекрутёр интервью», то
 * есть это по определению тот, кто встречу и проводит.
 */
export const PUBLIC_ROLE_TITLES: Record<string, string> = {
  recruiter: "Рекрутёр агентства Change",
  coordinator: "Координатор агентства Change",
  owner: "Руководитель агентства Change",
  co_owner: "Руководитель агентства Change",
  sales_manager: "Менеджер агентства Change",
  tech_admin: "Специалист агентства Change",
};

export const publicRoleTitle = (role?: string | null): string =>
  PUBLIC_ROLE_TITLES[String(role ?? "").trim()] ?? "Рекрутёр агентства Change";
